import { Head } from '@inertiajs/react';
import React from 'react';
import HeaderLayout from './HeaderLayout';
import SidebarLayout from './SidebarLayout';

export default function AppLayout({ title, children }) {
  return (
    <div className="relative">
      <Head title={title} />
      <SidebarLayout />
      <div className="lg:sidebar-offset relative min-h-screen bg-light">
        <HeaderLayout title={title} />
        <main className="mx-auto mt-16 max-w-6xl px-6 pb-10">{children}</main>
      </div>
    </div>
  );
}
